import { render, staticRenderFns } from "./FundsDiversification.vue?vue&type=template&id=629232de&scoped=true"
import script from "./FundsDiversification.vue?vue&type=script&lang=js"
export * from "./FundsDiversification.vue?vue&type=script&lang=js"
import style0 from "./FundsDiversification.vue?vue&type=style&index=0&id=629232de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629232de",
  null
  
)

export default component.exports